import { gql } from '@apollo/client'

export const ACCOMMODATIONS_FOR_CHANNEL_QUERY = gql`
  query AccommodationsForChannel($channelCode: String!) {
    accommodationsForChannel(channelCode: $channelCode) {
      Active
      Accommodations {
        label
        value
        entityCode
        displayEntityCode
        id
      }
    }
  }
`

export const CHANNEL_MAPPING_DATA_FOR_ACCOMMODATION_QUERY = gql`
  query ChannelMappingDataForAccommodation(
    $channelCode: String!
    $propertyCode: String!
  ) {
    channelMappingDataForAccommodation(
      channelCode: $channelCode
      propertyCode: $propertyCode
    ) {
      AdotelCode
      AdotelName
      ChannelCode
      RoomTypes {
        AdotelCode
        AdotelName
        ChannelCode
        RatePlans {
          AdotelCode
          AdotelName
          ChannelCode
          ProviderName
        }
      }
    }
  }
`

export const GENERATE_CHANNEL_MAPPING_WITH_RATEPLAN_MUTATION = gql`
  mutation GenerateChannelMappingWithRatePlan(
    $channelCode: String!
    $propertyCode: String!
    $input: ChannelMappingWithRatePlanInput!
  ) {
    generateChannelMappingWithRatePlan(
      channelCode: $channelCode
      propertyCode: $propertyCode
      input: $input
    ) {
      message
    }
  }
`

export const MODIFY_CHANNEL_MAPPING_WITH_RATEPLAN_MUTATION = gql`
  mutation ModifyChannelMappingWithRatePlan(
    $channelCode: String!
    $propertyCode: String!
    $input: ChannelMappingWithRatePlanInput!
  ) {
    modifyChannelMappingWithRatePlan(
      channelCode: $channelCode
      propertyCode: $propertyCode
      input: $input
    ) {
      message
    }
  }
`

export const GENERATE_CHANNEL_MAPPING_WITHOUT_RATEPLAN_MUTATION = gql`
  mutation GenerateChannelMappingWithoutRatePlan(
    $channelCode: String!
    $propertyCode: String!
    $input: ChannelMappingWithoutRatePlanInput!
  ) {
    generateChannelMappingWithoutRatePlan(
      channelCode: $channelCode
      propertyCode: $propertyCode
      input: $input
    ) {
      message
    }
  }
`

export const MODIFY_CHANNEL_MAPPING_WITHOUT_RATEPLAN_MUTATION = gql`
  mutation ModifyChannelMappingWithoutRatePlan(
    $channelCode: String!
    $propertyCode: String!
    $input: ChannelMappingWithoutRatePlanInput!
  ) {
    modifyChannelMappingWithoutRatePlan(
      channelCode: $channelCode
      propertyCode: $propertyCode
      input: $input
    ) {
      message
    }
  }
`

//
export const CHANNEL_MAPPING_MODIFY = gql`
  mutation ModifyChannelMapping(
    $input: ChannelPMSMappingInput!
    $channelCode: String!
  ) {
    modifychannelPMSMappings(input: $input, channelCode: $channelCode) {
      message
    }
  }
`
